import { useDispatch, useSelector } from "react-redux";
import { useAdminLayout } from "../../context/adminLayoutUseContext";
import Sidebar from "./AdminSideBar";
import Header from "./AdminHeader";
import "../styles/adminStyles.css";
import { Outlet } from "react-router-dom"; // Import Outlet from react-router-dom
import { toggleSidebar } from "../../redux/slices/adminSideBarSlice";

const AdminLayout = () => {
  const isCollapsed = useSelector((state) => state.sidebar.isCollapsed);
  const dispatch = useDispatch();

  // Get layout configuration from context
  const { layoutConfig } = useAdminLayout();
  const { title, showBackButton, scrollable } = layoutConfig;

  return (
    <div className="admin-page">
      {/* Sidebar */}
      <div className={`admin-sidebar ${isCollapsed ? "collapsed" : "expanded"}`}>
        <Sidebar isCollapsed={isCollapsed} toggleSidebar={() => dispatch(toggleSidebar())} />
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <Header title={title} showBackButton={showBackButton} />

        {/* Scrollable Content */}
        <main className={`admin-main-content ${scrollable ? "overflow-y-auto" : ""}`}>
          <Outlet /> 
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;